import React, { FunctionComponent, useContext, useState } from 'react'
import { Alert, Button, Card, Divider, Form, Input, Space } from 'antd'
import { css } from '@emotion/react'
import { useNavigate, useRouter, useSearch } from '@tanstack/react-router'
import { FeathersContext } from '@strac/react-client-feathers'
import { AuthContext } from '@strac/react-client-auth'
import { validateRecaptcha } from '../../utils/services/recaptcha'
import { useEnvironment } from '@strac/react-client-environment'
import { animate } from 'motion'
import { atIcon, atText } from '../../assets/logos'

const { Item } = Form

const LoginForm: FunctionComponent<any> = () => {
  const { client } = useContext(FeathersContext)

  const navigate = useNavigate()
  const router = useRouter()
  const search = useSearch({
    strict: false
  })

  const { setAuthUser } = useContext(AuthContext) as any

  const [form] = Form.useForm()
  const [error, setError] = useState<Error | any>(undefined)

  const [loading, setLoading] = useState<boolean>(false)

  const { REACT_APP_RECAPTCHA_SITE_KEY } = useEnvironment()

  const handleSubmit = async (values: any) => {
    setLoading(true)

    const loginCard: HTMLElement | null = document.getElementById('login-card')

    try {
      await validateRecaptcha(client, REACT_APP_RECAPTCHA_SITE_KEY)

      if (loginCard) {
        animate(loginCard, { height: 0, opacity: 0 }, { duration: 0.5 })
      }

      await client
        ?.authenticate({
          strategy: 'custom',
          access_code: values.access_code
        })
        .then((response: any) => {
          setAuthUser(response.assettrak_access)
          setError(undefined)
          if (search.redirect) {
            console.log(search.redirect)
            router.history.push(search.redirect)
          } else {
            navigate({ to: '/', replace: true })
          }
        })
    } catch (error: any) {
      console.error('LoginForm: caught error:', error)
      setLoading(false)
      setError(new Error('Invalid login.'))
      if (loginCard) {
        animate(loginCard, { height: '283px', opacity: 1 }, { duration: 0.5 })
      }
    }
  }

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Space direction={'vertical'}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {atIcon(loading)}
          </div>
          {atText()}
        </Space>
      </div>

      <div id={'login-card'}>
        <Card
          css={css`
          width: 450px;
          justify-self: center;
          align-self: center;
          overflow: hidden;
          margin-top: 50px;
        `}
        >
          <Form onFinish={handleSubmit} size={'large'} layout={'vertical'} form={form}>
            {error ? (
              <Item>
                <Alert message={error.message} type={'error'} />
              </Item>
            ) : null}
            <Item
              rules={[{ required: true, message: 'Please input your access code.' }]}
              name={'access_code'}
              label={'Access Code'}
              help={
                <span>
                Don't have an access code? Contact{' '}
                  <a href="mailto:support@strac.org?subject=AssetTrak Access">support@strac.org</a>
              </span>
              }
            >
              <Input.Password autoFocus={true} autoComplete={'password'} />
            </Item>
            <Divider />
            <Form.Item>
              <Button
                loading={loading}
                block={true}
                css={css`
                float: right;
              `}
                type={'primary'}
                htmlType={'submit'}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  )
}

export default LoginForm
